import uniq from 'lodash/uniq';

/**
 * Used to get the suppliers names defined on the master list import
 * This could be moved to GraphQL entirely if we can sort and do uniq
 * @param {{importData: import('./MatchSupplier').DataImport}} data
 * @returns
 */
export default function getSuppliers({ importData }) {
  const { allSuppliers: sourceSuppliers, allProducers: sourceProducers } =
    importData || {};

  const allSuppliers = sourceSuppliers?.nodes?.map(
    (row) => row?.supplierName?.rawText
  );
  const allProducers = sourceProducers?.nodes?.map(
    (row) => row?.producerName?.rawText
  );
  return uniq([].concat(allSuppliers, allProducers))
    ?.sort(supplierSorter)
    .filter(Boolean);
}

function supplierSorter(a, b) {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
}
